import { Subscription } from './model';

export const filterByPeriod = (period: string | number, arr?: Subscription[]) => {
  if (period === 'monthly') {
    return arr?.filter((el) => !(el.billing_cycle === 'year' && el.type === 'pro'));
  } else {
    return arr?.filter((el) => !(el.billing_cycle === 'month' && el.type === 'pro'));
  }
};
